import { render, staticRenderFns } from "./UserInstrumentationInfo.vue?vue&type=template&id=37b767dd"
import script from "./UserInstrumentationInfo.vue?vue&type=script&lang=js"
export * from "./UserInstrumentationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.3.4_css-loader@6.8.1_webpack@5.88.2__lodash@4.17_2b05b4b7daaef4c710e484e85375d138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports